<div style=" padding: 20px;background: #161616;" class="delete-container">
  <h4 class="fc_DEDEDE">Are you sure to delete this lot?</h4>
  <div style="margin-top: 20px; display: flex; justify-content:center">
    <button mat-button (click)="close()" class="cancel_button">Cancel</button>
    <button mat-button (click)="delete()" class="confirm_button">Delete</button>
  </div>
</div>